var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-generator',{attrs:{"schema":_vm.formSchema,"value":_vm.value,"label-width":"40%","value-width":"60%","label-class":"text-body-2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }